import React, { useState } from 'react'
import { Pane, TextInput, Label, Button } from '@leverege/ui-elements'
import { useValueChange } from '@leverege/ui-hooks'

import PermissionModel from './PermissionModel'
import S from './PermissionEditor.css'

export default function PermissionEditor( props ) {

  const { isCreate, isEditable = true, value : model, onChange, eventData } = props
  const [ showDialog, setShowDialog ] = useState( false )
  const onModelChange = useValueChange( PermissionModel, props )
  
  if ( model == null ) {
    return (
      <Pane variant="padding">
        No Permission Selected
      </Pane>
    )
  }
  const isCustom = PermissionModel.getScope( model ) === 'custom'
  const isCreated = model.createdAt != null
  return (
    <Pane variant="editor|padding">
      <div className={S.grid}>
        <Label variant="input">Name</Label>
        <TextInput
          variant="role"
          hint="Unique Permission Name"
          value={PermissionModel.getName( model )}
          size={30}
          eventData="setName"
          disabled={isCreated || !isEditable || !isCustom}
          autoFocus
          onChange={onModelChange}/>
        <Label variant="input">Display Name</Label>
        <TextInput
          variant="role"
          value={PermissionModel.getDisplayName( model )}
          size={30}
          eventData="setDisplayName"
          disabled={!isEditable}
          onChange={onModelChange}/>
        <Label variant="input">Category</Label>
        <TextInput
          variant="role"
          value={PermissionModel.getCategory( model )}
          size={30}
          eventData="setCategory"
          disabled={!isEditable || !isCustom}
          onChange={onModelChange}/>
        <Label variant="input">Description</Label>
        <TextInput
          variant="role"
          value={PermissionModel.getDescription( model )}
          size={30}
          eventData="setDescription"
          disabled={!isEditable}
          onChange={onModelChange}/>
      </div>
    </Pane>
  )
}
